import React from 'react';
import Immutable from 'immutable';
import ParentBoundComponent from '../../components/parentboundcomponent';
import RenderContext from '../../components/definitions/rendercontext';
import Binder from '../../components/definitions/binder';
import { getLookup } from '../../data/lookupstore';
import SearchFormModel from './searchformmodel';

export default class SearchFormModule extends ParentBoundComponent {
	constructor() {
		super();

		this.binder = new Binder({
			getData: this.getData,
			setData: this.setData,
			handleEvent: this.handleEvent,
			getLookup
		}, this);

	}

	onSearchRequested() {
		if (this.props.onSearchRequested) {
			this.props.onSearchRequested();
		}
	}

	handleEvent(eventType, params) {

		if (eventType === 'action') {
			if (params.source === 'form' || (params.source === 'button' && params.name === 'search')) {
				this.onSearchRequested();
			} else if (params.source === 'button' && params.name === 'clear') {
				this.setModel(this.getModel().clearFilter());
			}
		}
	}

	getModel() {
		return new SearchFormModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	render() {
		const ctx = new RenderContext(this.binder, ['filter']);
		if (this.props.ctx) {
			ctx.mergeCalcProperties(this.props.ctx.getCalcProperties());
		}
		const definition = this.getData().get('definition');
		if (!definition) {
			return null;
		}
		return definition.render(ctx);
	}
}

